/* eslint-disable no-negated-condition */
import { useRef, useState } from "react";

import { Tab } from "@headlessui/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import useResizeScreenModified from "common/hooks/useResizeScreenModified";

import ButtonNew from "components/atoms/ButtonNew";
import { FaCheck } from "components/atoms/Icon/fa/FaCheck";
import { FaChevronLeft } from "components/atoms/Icon/fa/FaChevronLeft";
import { FaChevronRight } from "components/atoms/Icon/fa/FaChevronRight";
import { HiChevronDoubleLeft } from "components/atoms/Icon/hi/HiChevronDoubleLeft";
import { HiChevronDoubleRight } from "components/atoms/Icon/hi/HiChevronDoubleRight";
import Img from "components/atoms/Img";
import Title from "components/atoms/Title";
import Breadcrumb from "components/molecules/Breadcrumb";
import Banner from "components/organisms/Banner";

import FormWhitepaper from "./FormWhitepaper";

import styles from "./Index.module.scss";

const WhitePaperTemplate = ({ data }) => {
  const [showFormDownload, setShowFormDownload] = useState(false);
  const [screen, setScreen] = useState();
  const [indexTitle, setIndexTitle] = useState(0);
  const swiperRef = useRef();

  useResizeScreenModified(setScreen);

  return (
    <>
      <Banner
        minHeightBanner="lg:min-h-[1370px] min-h-[750px] relative"
        bgStyle={{
          background: "none",
        }}
      >
        {screen !== "DESKTOP" ? (
          <Img
            alt="banner-img"
            className="absolute left-0 top-0 h-full w-full"
            {...data.banner.imageMb}
          />
        ) : (
          <Img
            alt="banner-img"
            className="absolute left-0 top-0 h-full w-full"
            {...data.banner.image}
          />
        )}
        <div className="relative z-10 mb-10">
          {Array.isArray(data.banner.breadcrumbs) && (
            <div className="flex w-full justify-center">
              <div
                className={
                  "mb-6 inline-block w-auto text-center text-bbc-white lg:mb-8"
                }
              >
                <Breadcrumb items={data.banner.breadcrumbs} />
              </div>
            </div>
          )}
          <div className="relative mb-10">
            <Title className="relative z-10 mb-4 text-center text-4xl font-semibold leading-[50px] text-bbc-white lg:mb-2 lg:text-bbc-40px lg:text-[64px] lg:leading-[96px]">
              <span className="relative z-10">
                Entity Formation <br className="block lg:hidden" />
                On <br className="hidden lg:block" />A{" "}
              </span>
              <span className="relative">
                <span className="absolute -bottom-2 left-0 z-0 grid w-full place-items-center">
                  <Img alt="bg-title" {...data.banner.bgTitle} />
                </span>
                <span className="relative z-10 inline-block">New Horizon</span>
              </span>
            </Title>
          </div>
          <div
            className="hidden text-center text-bbc-white lg:block"
            dangerouslySetInnerHTML={{ __html: data.banner.description }}
          ></div>
          <div
            className="block text-center text-bbc-white lg:hidden"
            dangerouslySetInnerHTML={{ __html: data.banner.descriptionMobile }}
          ></div>
          <div className="mt-6 mb-2 flex justify-center lg:mt-10">
            <ButtonNew
              onClick={() => setShowFormDownload(true)}
              className="rounded-full bg-bbc-yellow-500 px-12 py-3 text-lg font-semibold text-bbc-white duration-200 ease-in-out hover:bg-bbc-white hover:text-bbc-yellow-500"
            >
              Explore Now
            </ButtonNew>
          </div>
          <div className="relative block lg:hidden">
            <Img
              alt="tablet-whitepaper"
              className="relative z-10"
              {...data.banner.imageBottom}
            />
          </div>
        </div>
        <div className="absolute bottom-0 left-0 grid w-full place-items-center">
          <Img
            src="/assets/images/offshore/guide-and-tool/whitepaper/wave1-offshore-whitepaper.png"
            alt="wave1"
            className="absolute -bottom-2 left-0 right-0 z-0 w-full lg:-bottom-1 2xl:max-h-[700px]"
            width={1920}
            height={676}
          />
          <div className="hidden lg:block">
            <Img
              alt="tablet-whitepaper"
              className="relative z-10"
              {...data.banner.imageBottom}
            />
          </div>
        </div>
      </Banner>
      <section className="relative mb-10 -mt-10 bg-[#f7fdff] sm:mb-0 xl:-mb-16">
        <div className="container overflow-hidden">
          <Title
            as="h2"
            className="mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:mb-10 lg:text-bbc-40px"
          >
            <span
              dangerouslySetInnerHTML={{ __html: data.dataServiceFirm.title }}
            ></span>
          </Title>
          <div className="row pb-8 lg:pb-0">
            {data.dataServiceFirm.leftContent && (
              <div className="flex w-full flex-col justify-center text-center  lg:w-1/2 lg:text-left">
                <p className="mb-4 hidden lg:block">
                  {data.dataServiceFirm.leftContent.description}
                </p>
                <p className="mb-4 block lg:hidden">
                  {data.dataServiceFirm.leftContent.descriptionMobile}
                </p>
                <p className="text-2xl font-semibold text-[#FF5630]">
                  {data.dataServiceFirm.leftContent.title}
                </p>
                {data.dataServiceFirm.leftContent.listContent &&
                  data.dataServiceFirm.leftContent.listContent.map(
                    (item, index) => (
                      <div key={index} className="mt-4 lg:mt-6">
                        <p className="mb-4 text-2xl font-semibold text-bbc-brand-800">
                          {item.subTitle}
                        </p>
                        <p>{item.content}</p>
                      </div>
                    )
                  )}
              </div>
            )}
            <div className="mt-6 grid w-full grid-cols-2 grid-rows-2 gap-3 lg:mt-0 lg:w-1/2 xl:gap-7">
              {data.dataServiceFirm.rightContent &&
                data.dataServiceFirm.rightContent.map((item, index) => (
                  <div
                    key={index}
                    className="rounded-[32px] p-6 lg:px-7 lg:py-10 xl:h-[255px] xl:w-[255px]"
                    style={{ background: `${item.background}` }}
                  >
                    <div className="flex h-full flex-col justify-between">
                      <Img
                        alt={item.text.toLowerCase()}
                        className="w-14 lg:w-auto"
                        {...item.icon}
                      />
                      <p className="text-normal mt-2 font-semibold text-bbc-white lg:mt-0 lg:text-2xl">
                        {item.text}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className="mt-9">
            {data.dataTitle && (
              <div className="ml-[287px] mb-6 hidden lg:block">
                <p className="text-2xl font-semibold text-bbc-brand-700">
                  {data.dataTitle[indexTitle].title}
                </p>
                {data.dataTitle[indexTitle].description && (
                  <p className="mt-4">
                    {data.dataTitle[indexTitle].description}
                  </p>
                )}
              </div>
            )}
            {data.dataChart && (
              <Tab.Group>
                <div
                  className={`flex ${styles.charts} relative z-10 flex-col lg:flex-row`}
                >
                  <Tab.List>
                    <div
                      style={{
                        boxShadow: "0px 25px 22px rgba(0, 126, 255, 0.15)",
                      }}
                      className="relative flex min-w-[255px] flex-col items-start rounded-2xl bg-bbc-white p-4 lg:mr-8"
                    >
                      {data.dataChart.map((item, index) => (
                        <Tab
                          key={index}
                          as={"div"}
                          className={({ selected }) =>
                            selected
                              ? `${"mb-4 cursor-pointer border-bbc-brand-600 text-bbc-brand-600 last:mb-0"}`
                              : ` ${"mb-4 cursor-pointer border-transparent bg-transparent text-bbc-neutral-600 last:mb-0 hover:text-bbc-brand-600"} `
                          }
                        >
                          <ButtonNew
                            onClick={() => setIndexTitle(index)}
                            className={`${
                              indexTitle == index
                                ? "font-semibold"
                                : "font-normal"
                            }`}
                          >
                            {item.title}
                          </ButtonNew>
                        </Tab>
                      ))}
                    </div>
                  </Tab.List>
                  <Tab.Panels className="mt-6 w-full lg:mt-0">
                    {data.dataChart.map((item, index) => (
                      <Tab.Panel as="div" key={index}>
                        <div className="mb-6 block text-center lg:hidden">
                          {item.title && (
                            <p className="text-2xl font-semibold text-bbc-brand-700">
                              {item.title}
                            </p>
                          )}
                          {item.description && (
                            <p className="mt-4">{item.description}</p>
                          )}
                        </div>
                        <div className="mb-6 rounded-lg bg-bbc-white p-4 drop-shadow-xl xl:py-6 xl:px-9">
                          {item.text && (
                            <p className="mb-4 text-center">{item.text}</p>
                          )}
                          {item.image && (
                            <Img {...item.image} alt="chart-image" />
                          )}
                          {item.style && item.style == "booming" && (
                            <div
                              className={`${item.style} text-[6px] leading-[10px] md:text-sm xl:text-base`}
                            >
                              <div className="sidebar">
                                {item.vertical &&
                                  item.vertical.map((el, idx) => (
                                    <div key={idx}>{el}</div>
                                  ))}
                              </div>
                              <div className="content">
                                {item.listItem &&
                                  item.listItem.map((el, idx) => (
                                    <div
                                      className={"item"}
                                      style={{
                                        height: `${
                                          screen !== "DESKTOP"
                                            ? el.heightMb
                                            : el.height
                                        }`,
                                      }}
                                      key={idx}
                                    >
                                      <div className="dataHolder">
                                        <div
                                          className="data"
                                          dangerouslySetInnerHTML={{
                                            __html: el.data,
                                          }}
                                        ></div>
                                      </div>
                                      <div className="percentHolder">
                                        <div
                                          className="percent"
                                          style={{ height: "100%" }}
                                        ></div>
                                      </div>
                                      <div className="year">{el.year}</div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          )}
                          {item.style && item.style == "players" && (
                            <div className={`${item.style}`}>
                              {item.listItem &&
                                item.listItem.map((el, idx) => (
                                  <div key={idx} className="mt-1 flex lg:mt-0">
                                    <div className="mr-4 w-1/4 text-right">
                                      {el.name}
                                    </div>
                                    <div className="flex w-3/4 items-center overflow-hidden">
                                      <div
                                        className="item"
                                        style={{ width: `${el.width}` }}
                                      ></div>
                                      <div className="itemText">{el.value}</div>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          )}
                          {item.style && item.style == "powerhouses" && (
                            <div className={`${item.style}`}>
                              <div className="leftContent">
                                <div className="flex h-full w-full flex-col justify-center">
                                  <div className="text-right text-[6px] font-medium lg:text-[12px]">
                                    $160 billion
                                  </div>
                                  <div className="column">
                                    {item.leftContent &&
                                      item.leftContent.map((el, idx) => (
                                        <div
                                          className="item"
                                          key={idx}
                                          style={{ height: `${el.height}` }}
                                        >
                                          <div className="flex w-2/3 items-center justify-end pr-1 text-[6px] font-medium leading-[10px] lg:pr-2 lg:text-[12px]">
                                            {el.name}
                                          </div>
                                          <div
                                            style={{
                                              backgroundColor: `${el.color}`,
                                            }}
                                            className="percent w-1/3 text-[6px] leading-[10px] lg:text-sm"
                                          >
                                            <p className="text">
                                              {el.value ? el.value : ""}
                                            </p>
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                  <div className="text-right text-[6px] font-medium lg:text-[12px]">
                                    Market size
                                  </div>
                                </div>
                              </div>
                              <div className="rightContent">
                                <p className="mb-2 text-[10px] font-semibold text-bbc-yellow-500 lg:mb-6 lg:text-base">
                                  {item.chartTitle}
                                </p>
                                <hr className="border-bbc-brand-700" />
                                <div className="relative">
                                  {item.rightContent &&
                                    item.rightContent.map((el, idx) => (
                                      <div
                                        className="row mt-2 text-[6px] font-medium leading-[10px] text-bbc-brand-800 lg:text-[10px] xl:text-sm"
                                        key={idx}
                                      >
                                        <div className="col-4 flex items-center justify-end pl-0 pr-1 lg:pr-4">
                                          <div>{el.name}</div>
                                          <Img
                                            alt={el.name}
                                            className="ml-2 w-3 lg:w-6"
                                            {...el.image}
                                          />
                                        </div>
                                        <div className="col-8 flex items-center overflow-hidden p-0">
                                          <div
                                            className="percent mr-1 rounded-full lg:mr-2"
                                            style={{
                                              width: `${el.width}`,
                                              background:
                                                "linear-gradient(223.53deg, #3EDCEB 31.56%, #2594FF 65.16%, #5533FF 102.22%)",
                                            }}
                                          ></div>
                                          <div className="value">
                                            {el.value}
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  <div className="absolute bottom-20 right-2 grid h-16 w-16 place-content-center rounded-full bg-bbc-brand-600 text-center text-[6px] leading-[10px] text-bbc-white sm:right-6 sm:h-24 sm:w-24 sm:text-[10px] sm:leading-4 md:right-10 lg:bottom-32 xl:h-36 xl:w-36 xl:text-sm">
                                    ~80% of
                                    <br /> the global
                                    <br /> industry
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        {item.note && (
                          <p className="text-sm text-[#B7B7B7]">{item.note}</p>
                        )}
                        {item.source && (
                          <p
                            className="text-sm text-[#B7B7B7]"
                            dangerouslySetInnerHTML={{ __html: item.source }}
                          ></p>
                        )}
                      </Tab.Panel>
                    ))}
                  </Tab.Panels>
                </div>
              </Tab.Group>
            )}
          </div>
        </div>
      </section>
      <section className="relative mb-5 overflow-hidden bg-[#f7fdff] pt-4 pb-16 sm:pt-20 lg:mb-20 lg:pt-52 lg:pb-24">
        <Img
          alt="bg-adversity"
          className="absolute left-0 bottom-0 z-0 hidden h-full w-full sm:block"
          {...data.dataAdversity.background}
        />
        <div className="block after:absolute after:top-2 after:-right-10 after:z-0 after:h-[97%] after:w-[120%] after:-rotate-2 after:bg-bbc-brand-700 after:content-[''] sm:hidden after:sm:-right-3 after:sm:w-[105%]"></div>
        <div className="container relative z-10">
          <Title
            as="h2"
            className="mb-6 text-center text-bbc-30px font-semibold text-bbc-white lg:mb-10 lg:text-bbc-40px"
          >
            In Adversity Lies <br className="block lg:hidden" />
            <span className="relative text-bbc-yellow-500">
              <Img
                alt="bg-text"
                className="absolute left-0 top-0 z-0 w-full"
                {...data.banner.bgTitle}
              />
              <span className="relative z-10">Opportunity</span>
            </span>
          </Title>
          <p className="mb-6 hidden text-center text-bbc-white lg:block">
            {data.dataAdversity.description1}
          </p>
          <p className="hidden text-center font-semibold text-bbc-white lg:block">
            {data.dataAdversity.description2}
          </p>
          <p className="mb-6 block text-center text-bbc-white lg:hidden">
            {data.dataAdversity.descriptionMobile}
          </p>
          <div className="hidden lg:block">
            <div className="mt-6 grid grid-cols-2 grid-rows-2 gap-7">
              {data.dataAdversity.listContent &&
                data.dataAdversity.listContent.map((item, index) => {
                  return (
                    <div key={index} className="h-full">
                      <Swiper
                        className="h-full"
                        modules={[Autoplay, Navigation]}
                        preloadImages={false}
                        allowTouchMove={false}
                        navigation={{
                          nextEl: ".slider-button-next",
                          prevEl: ".slider-button-prev",
                        }}
                        slidesPerView={1}
                        spaceBetween={50}
                      >
                        {item.data.map((el, idx) => (
                          <SwiperSlide key={idx}>
                            <div
                              className={`flex h-full flex-col justify-between rounded-3xl ${
                                idx == 0 ? "bg-bbc-white" : "bg-bbc-yellow-500"
                              } p-8`}
                            >
                              <div>
                                <Img
                                  alt="ad-icon"
                                  className="mb-4"
                                  {...el.icon}
                                />
                                <p className="mb-4 text-xl font-semibold text-bbc-brand-700">
                                  {el.title}
                                </p>
                                {el.content &&
                                  el.content.map((el, idx) => (
                                    <p
                                      className="mb-6 font-normal last:mb-0"
                                      key={idx}
                                      dangerouslySetInnerHTML={{
                                        __html: el,
                                      }}
                                    ></p>
                                  ))}
                                {el.customText && (
                                  <div
                                    className="mt-4"
                                    dangerouslySetInnerHTML={{
                                      __html: el.customText,
                                    }}
                                  ></div>
                                )}
                              </div>
                              {idx == 0 ? (
                                <div>
                                  <ButtonNew className="slider-button-next flex items-center font-medium text-bbc-secondary-100 hover:text-bbc-yellow-500">
                                    <HiChevronDoubleRight /> See what
                                    opportunity awaits you!
                                  </ButtonNew>
                                </div>
                              ) : (
                                <div>
                                  {el.sourceText && (
                                    <div
                                      className="mb-4 text-sm font-normal text-[#000000a6]"
                                      dangerouslySetInnerHTML={{
                                        __html: el.sourceText,
                                      }}
                                    ></div>
                                  )}
                                  <ButtonNew className="slider-button-prev flex items-center font-medium text-bbc-secondary-100 hover:text-bbc-white">
                                    <HiChevronDoubleLeft /> Back
                                  </ButtonNew>
                                </div>
                              )}
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="block lg:hidden">
            <Swiper
              spaceBetween={30}
              rewind={true}
              modules={[Pagination]}
              pagination={{
                el: ".bbc-slide-pagination",
                clickable: true,
                bulletClass: "bbc-pagination-bullet !border-bbc-white",
                bulletActiveClass:
                  "bbc-pagination-bullet-active h-2.5 w-10 !bg-bbc-white",
              }}
            >
              {data.dataAdversity.listContent &&
                data.dataAdversity.listContent.map((item, index) => {
                  return (
                    <SwiperSlide key={index}>
                      <Swiper
                        modules={[Autoplay, Navigation]}
                        className="h-full"
                        preloadImages={false}
                        allowTouchMove={false}
                        navigation={{
                          nextEl: ".slider-button-next",
                          prevEl: ".slider-button-prev",
                        }}
                        slidesPerView={1}
                        spaceBetween={50}
                      >
                        {item.data.map((el, idx) => (
                          <SwiperSlide key={idx}>
                            <div
                              className={`flex flex-col rounded-3xl ${
                                idx == 0 ? "bg-bbc-white" : "bg-bbc-yellow-500"
                              } p-6`}
                            >
                              <div>
                                <Img
                                  alt="ad-icon"
                                  className="mb-4"
                                  {...el.icon}
                                />
                                <p className="mb-4 text-xl font-semibold text-bbc-brand-700">
                                  {el.titleMb}
                                </p>
                                {el.contentMb &&
                                  el.contentMb.map((el, idx) => (
                                    <p
                                      className="mb-6 font-normal last:mb-0"
                                      key={idx}
                                      dangerouslySetInnerHTML={{
                                        __html: el,
                                      }}
                                    ></p>
                                  ))}
                                {!el.customTextMb
                                  ? el.customText && (
                                      <div
                                        className="mt-4"
                                        dangerouslySetInnerHTML={{
                                          __html: el.customText,
                                        }}
                                      ></div>
                                    )
                                  : el.customTextMb && (
                                      <div
                                        className="mt-4"
                                        dangerouslySetInnerHTML={{
                                          __html: el.customTextMb,
                                        }}
                                      ></div>
                                    )}
                              </div>
                              {idx == 0 ? (
                                <div className="slider-button-next mt-6">
                                  <ButtonNew className="flex text-left font-medium text-bbc-secondary-100 hover:text-bbc-yellow-500">
                                    <HiChevronDoubleRight className="mt-1" />{" "}
                                    See what opportunity awaits you!
                                  </ButtonNew>
                                </div>
                              ) : (
                                <div className="">
                                  {el.sourceText && (
                                    <div
                                      className="mb-4 mt-6 text-sm font-normal text-[#000000a6]"
                                      dangerouslySetInnerHTML={{
                                        __html: el.sourceText,
                                      }}
                                    ></div>
                                  )}
                                  <ButtonNew className="slider-button-prev mt-6 flex items-center font-medium text-bbc-secondary-100">
                                    <HiChevronDoubleLeft /> Back
                                  </ButtonNew>
                                </div>
                              )}
                            </div>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </SwiperSlide>
                  );
                })}
              <div
                className={"bbc-slide-pagination z-20 pt-6 text-center"}
              ></div>
            </Swiper>
          </div>
          <p className="mt-6 hidden text-center text-sm font-normal text-[#FAFAFAA6] lg:block">
            {data.dataAdversity.note}
          </p>
          <div className="mt-5 flex justify-center">
            <ButtonNew
              as="a"
              target="_blank"
              href="/offshore/contact-us"
              className="rounded-full bg-bbc-yellow-500 py-3 px-6 font-semibold text-bbc-white duration-200 ease-out hover:bg-bbc-white hover:text-bbc-yellow-500 hover:drop-shadow-lg"
            >
              Contact Us
            </ButtonNew>
          </div>
        </div>
      </section>
      <section className="mb-0">
        <div className="container flex">
          <div className="w-full lg:w-1/2">
            <div className="mb-6 block lg:hidden">
              <Img
                src="/assets/images/offshore/guide-and-tool/whitepaper/incorporation-offshore-whitepaper.png"
                alt="incorporation"
                width={656}
                height={488}
              />
            </div>
            <Title
              as="h2"
              className="mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-700 lg:mb-10 lg:text-bbc-40px"
            >
              <span className="relative mr-2 px-2 text-[#FF5630] lg:px-4">
                <Img
                  alt="bg-text"
                  className="absolute left-0 bottom-1 z-0 w-full lg:bottom-0"
                  {...data.banner.bgTitle}
                />
                <span className="relative z-10">Digital</span>
              </span>
              Incorporation
            </Title>
            <p className="mb-6 text-center lg:text-left">
              As the need for entity formation grows, firms must reconsider how
              they will meet these demands and be more competitive when pitching
              for new projects.
            </p>
            <p className="mb-6 text-center lg:text-left">
              {" "}
              In this context, digital adoption is inevitable, and
            </p>
            <div className="row items-center">
              <div className="col-12 flex justify-center lg:col-6">
                <Img
                  src="/assets/images/offshore/guide-and-tool/whitepaper/70-offshore-whitepaper.png"
                  alt="70-percent"
                  className="mx-auto w-3/4 lg:w-full"
                  width={263}
                  height={138}
                />
              </div>
              <div className="col-12 mt-6 text-center lg:col-6 lg:mt-0 lg:text-left">
                <p className="text-2xl font-semibold">
                  of firms stated that they are investing in digital
                  incorporation to help their clients
                </p>
              </div>
            </div>
          </div>
          <div className="hidden w-1/2 lg:block">
            <Img
              src="/assets/images/offshore/guide-and-tool/whitepaper/incorporation-offshore-whitepaper.png"
              alt="incorporation"
              width={656}
              height={488}
            />
          </div>
        </div>
      </section>
      <section>
        <div className="mt-10 overflow-x-hidden lg:container lg:mt-20 lg:overflow-visible">
          <div className="relative px-4 pt-10 pb-10 text-bbc-white lg:bg-none lg:px-20 lg:pb-[60px] lg:pt-[100px]">
            <div
              style={{ zIndex: "1" }}
              className="absolute left-2 top-0 hidden h-full w-full rotate-2 rounded-[40px] bg-[#00A6FF] after:absolute after:top-2 after:-right-16 after:z-0 after:h-[97%] after:w-[110%] after:-rotate-3 after:rounded-[40px] after:bg-bbc-brand-700 after:content-[''] lg:block"
            ></div>
            <div className="block after:absolute after:top-4 after:-right-10 after:z-0 after:h-[97%] after:w-[120%] after:-rotate-2 after:bg-bbc-brand-700 after:content-[''] after:sm:-right-3 after:sm:w-[105%] lg:hidden"></div>
            <Swiper
              autoplay={false}
              rewind={true}
              modules={[Autoplay, Pagination]}
              onBeforeInit={(swiper) => {
                swiperRef.current = swiper;
              }}
              spaceBetween={30}
              pagination={{
                el: ".bbc-slide-pagination",
                clickable: true,
                bulletClass: "bbc-pagination-bullet !border-bbc-white",
                bulletActiveClass:
                  "bbc-pagination-bullet-active h-2.5 w-10 !bg-bbc-white",
              }}
            >
              {data.dataIncorpSlide.length > 0 &&
                data.dataIncorpSlide.map((item, index) => (
                  <SwiperSlide key={index} className="!h-auto">
                    <div className="row h-full lg:items-center">
                      <div className="grid place-items-center lg:col-4 lg:place-items-end">
                        <Img className="w-40 lg:w-full" {...item.image} />
                      </div>
                      <div className="col-12 lg:col-8 lg:mt-0">
                        <Title
                          as="h4"
                          className="text-center text-xl font-semibold text-bbc-yellow-300 lg:text-left lg:text-2xl "
                        >
                          {item.title}
                        </Title>
                        <div className="lg:pr-16">
                          {screen == "DESKTOP"
                            ? item.content.map((el, idx) => (
                                <p key={idx} className="mt-4 flex">
                                  <span className="mr-2 block pt-1">
                                    <FaCheck className=" text-bbc-green-400" />
                                  </span>
                                  <span>{el}</span>
                                </p>
                              ))
                            : item.contentMb.map((el, idx) => (
                                <p key={idx} className="mt-4 flex">
                                  <span className="text-center">{el}</span>
                                </p>
                              ))}
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              <div
                className={
                  "bbc-slide-pagination z-20 pt-6 text-center lg:pb-10"
                }
              ></div>
            </Swiper>
            <div
              style={{ backgroundColor: "rgba(191, 189, 189, 0.2)" }}
              onClick={() => swiperRef.current?.slidePrev()}
              className={
                "bbc-button-prev absolute top-1/2 left-12 z-10 hidden h-12 w-12 -translate-y-1/2 -translate-x-1/2 cursor-pointer items-center justify-center rounded-full transition-all duration-150 ease-in-out hover:opacity-60 lg:flex"
              }
            >
              <FaChevronLeft size={16} className="text-white" />
            </div>
            <div
              style={{ backgroundColor: "rgba(191, 189, 189, 0.2)" }}
              onClick={() => swiperRef.current?.slideNext()}
              className={
                "bbc-button-next absolute top-1/2 right-14 z-10 hidden h-12 w-12 -translate-y-1/2 translate-x-1/2 cursor-pointer items-center justify-center rounded-full transition-all duration-150 ease-in-out hover:opacity-60 lg:flex"
              }
            >
              <FaChevronRight size={16} className="text-white" />
            </div>
          </div>
        </div>
      </section>
      <section className="xl:-mb-24">
        <div className="container">
          <div className="row lg:items-center">
            <div className="col-12 lg:col-6">
              <div className="mb-6 block lg:hidden">
                <div className="flex justify-center">
                  <Img
                    src="/assets/images/offshore/guide-and-tool/whitepaper/goglobal-offshore-whitepaper.png"
                    alt="go-global "
                    className="object-center"
                    width={538}
                    height={370}
                  />
                </div>
              </div>
              <Title
                as="h2"
                className="mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-700 lg:mb-10 lg:text-left lg:text-bbc-40px"
              >
                Go Digital
                <span className="ml-2 text-[#FF5630]">Go Global</span>
              </Title>
              <p className="hidden text-left lg:block">
                Whether your firms focus on consulting, advisory, accounting, or
                other professional services,{" "}
                <span className="font-semibold text-bbc-brand-600">
                  BBCIncorp
                </span>{" "}
                digital incorporation helps you drive better clients&apos;
                experiences while adapting to global regulations seamlessly,
                without any headache.
              </p>
              <p className="block text-center lg:hidden">
                We help you drive better clients&apos; experiences while
                adapting to global regulations seamlessly, without any headache.
              </p>
            </div>
            <div className="col-12 hidden lg:col-6 lg:block">
              <Img
                src="/assets/images/offshore/guide-and-tool/whitepaper/goglobal-offshore-whitepaper.png"
                alt="go-global"
                width={538}
                height={370}
              />
            </div>
          </div>
        </div>
      </section>
      <section
        className={`${styles.lastSection} relative -mb-20 min-h-screen pb-32 sm:-mb-20 md:-mb-32 md:pb-32 lg:-mb-36 lg:pb-44 xl:-mb-44 xl:pt-[125px]`}
      >
        <Img
          src="/assets/images/offshore/guide-and-tool/whitepaper/city_Mb-offshore-whitepaper.png"
          alt="city-background"
          className="absolute left-0 bottom-0 right-0 z-0 block h-full w-full sm:hidden"
          width={375}
          height={1455}
        />

        <Img
          src="/assets/images/offshore/guide-and-tool/whitepaper/bgcity-offshore-whitepaper.png"
          alt="city-background"
          className="absolute left-0 bottom-0 right-0 z-0 hidden h-full sm:block 2xl:w-full"
          width={1920}
          height={1119}
        />

        <div className="container relative z-10 h-full">
          <Title
            as="h2"
            className="flex flex-col items-center text-bbc-30px font-semibold uppercase text-bbc-brand-700 lg:mb-32 lg:text-bbc-40px"
          >
            <span>What We Offer</span>
            <Img
              src="/assets/images/offshore/guide-and-tool/whitepaper/curvedline-offshore-whitepaper.png"
              alt="curved-line"
              width={272}
              height={18}
            />
          </Title>
          <div className="grid grid-cols-1 lg:grid-cols-3 lg:gap-8">
            {data.dataBeOurPartner &&
              data.dataBeOurPartner.map((item, index) => (
                <div
                  key={index}
                  className={`flex flex-col items-center ${
                    index == 1 ? "lg:mt-20" : ""
                  }`}
                >
                  <ButtonNew
                    as="a"
                    target="_blank"
                    href={item.link}
                    className={`z-10 w-4/5 translate-y-1/2 rounded-lg py-3 text-center text-2xl font-semibold text-bbc-white duration-200 ease-in ${
                      index == 0
                        ? "bg-[#E5006E] hover:bg-[#a60351]"
                        : index == 1
                        ? "bg-[#F33E95] hover:bg-[#ad2d6b] "
                        : "bg-[#FF8FC5] hover:bg-[#b3648a]"
                    } ]`}
                  >
                    {item.title}
                  </ButtonNew>
                  <div className="rounded-3xl border border-bbc-white bg-[#00000059] px-8 pb-6 pt-12 text-center text-bbc-white backdrop-blur-md">
                    {item.description}
                  </div>
                </div>
              ))}
          </div>
          <div className="mt-10 flex justify-center">
            <ButtonNew
              as="a"
              target="_blank"
              href="/offshore/become-our-partner"
              className=" rounded-full bg-bbc-yellow-500 py-3 px-6 font-semibold text-bbc-white duration-200 ease-out hover:bg-bbc-white hover:text-bbc-yellow-500 hover:drop-shadow-lg"
            >
              Be Our Partner
            </ButtonNew>
          </div>
        </div>
      </section>
      <FormWhitepaper
        show={showFormDownload}
        onHide={() => setShowFormDownload(false)}
      />
    </>
  );
};

export default WhitePaperTemplate;
